import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

// styles
import * as styles from "./Header.module.css";

const HeaderWithLogo = props => {
  return (
    <>
      <div
        className={`${styles.headerWrapper} ${
          !props.isHome && "whiteBgWrapper"
        } `}
        id="topHeader"
      >
        <nav
          className={`navbar navbar-expand-lg fixed-top navbar-light
            ${props.background === "white" ? styles.navBar3 : styles.navBar2}
            ${props.newHeaderbackground ? styles.navbarNewHeader : ""}
          `}
        >
          <div
            className={`container ${
              props.logoPosition === "center" ? styles.centerLogo : null
            }`}
          >
            {props.logoOnClickRedirect ? (
              <div className="navbar-brand">
                <Link to={props.logoOnClickRedirect}>
                  {props.background === "white" ? (
                    <StaticImage
                      src="../../images/twin-logo/twinLogo2_2024.png"
                      alt="Banner"
                      placeholder="blurred"
                      quality={90}
                      className={styles.logoImage}
                      loading="lazy"
                    />
                  ) : (
                    <StaticImage
                      src="../../images/twin-logo/twinLogo3_2024.png"
                      alt="Banner"
                      placeholder="blurred"
                      quality={90}
                      className={styles.logoImage}
                      loading="lazy"
                    />
                  )}
                </Link>
              </div>
            ) : (
              <div className="navbar-brand">
                {props.background === "white" ? (
                  <StaticImage
                    src="../../images/twin-logo/twinLogo2_2024.png"
                    alt="Banner"
                    placeholder="blurred"
                    quality={90}
                    className={styles.logoImage}
                    loading="lazy"
                  />
                ) : (
                  <StaticImage
                    src="../../images/twin-logo/twinLogo3_2024.png"
                    alt="Banner"
                    placeholder="blurred"
                    quality={90}
                    className={styles.logoImage}
                    loading="lazy"
                  />
                )}
              </div>
            )}
          </div>
        </nav>
      </div>
    </>
  );
};

export default HeaderWithLogo;

// NOTE
// props.logoPosition = "center" then logo will be placed to center and if value is null then it will positioned in left
// logoOnClickRedirect = url for redirection. For Ex:- logoOnClickRedirect="/"
